<form
    class="flex flex-col px-20 py-10"
    [formGroup]="form">
    <button
        type="button"
        class="mb-5 self-start"
        mat-flat-button
        color="primary"
        (click)="addChallengeBlock(null)">
        Add new block
    </button>
    <table
        class="mat-elevation-z8 mb-5"
        mat-table
        [dataSource]="dataSource"
        formArrayName="challengeBlocks">
        <ng-container matColumnDef="id">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Id
            </th>
            <td
                mat-cell
                *matCellDef="let element; let index = index">
                {{ element.blockId }}
            </td>
        </ng-container>
        <ng-container matColumnDef="duration">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Duration
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <input
                        matInput
                        formControlName="duration" />
                    <mat-hint align="end">d.hh:mm</mat-hint>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="goals">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Goals
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <mat-select
                        multiple
                        formControlName="offerGoalsIds"
                        panelClass="min-w-fit">
                        @for (
                            goal of offerStore.offer()?.goals ?? [] | appFilter: filterFn;
                            track $index
                        ) {
                            <mat-option [value]="goal.id">{{ goal.eventName }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="extraReward">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Cash reward
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <input
                        matInput
                        type="number"
                        noScroll
                        formControlName="extraReward" />
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="extraExpReward">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Exp reward
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <input
                        matInput
                        type="number"
                        noScroll
                        formControlName="extraExpReward" />
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="order">
            <th
                mat-header-cell
                *matHeaderCellDef>
                Order
            </th>
            <td
                class="!py-5"
                mat-cell
                *matCellDef="let element; let index = index"
                [formGroupName]="index">
                <mat-form-field>
                    <input
                        matInput
                        type="number"
                        noScroll
                        formControlName="order" />
                </mat-form-field>
            </td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th
                mat-header-cell
                *matHeaderCellDef></th>
            <td
                mat-cell
                *matCellDef="let element; let index = index">
                <button
                    mat-icon-button
                    color="warn"
                    (click)="deleteChallengeBlock(element.blockId)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns()"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns()"></tr>
    </table>
    <button
        type="button"
        class="mb-5 self-start"
        mat-flat-button
        color="primary"
        (click)="updateChallengeBlocks()">
        Save changes
    </button>
</form>
